// removed by extract-text-webpack-plugin
module.exports = {"h3":"h3___9C-AC","wrap":"wrap___2NGj0","closed":"closed___1D8Vu","arrow":"arrow___iFfd8","openArrow":"openArrow___k7t9Z","h4":"h4___388_n","p":"p___2Cd-q"};


//////////////////
// WEBPACK FOOTER
// /app/js/components/TemplateInstructions/styles.scss
// module id = 339
// module chunks = 0